module.exports = __webpack_public_path__ + "24e004ab/img/arrow-left-icon.785c715c.svg";